module.exports = __webpack_public_path__ + "img/flashing2.7420feaf.png";